import React, { Fragment } from "react";
import { DictionaryControl } from "./DictionaryControl";
import EmailRenderer from "./renderers/EmailRenderer";
import AddressRenderer from "./renderers/AddressRenderer";
import PhoneNumberRenderer from "./renderers/PhoneNumberRenderer";

interface EmergencyContactsViewProps
{
    data: Contacts;
}

export default class EmergencyContactsView extends React.Component<EmergencyContactsViewProps>
{
    constructor(props: EmergencyContactsViewProps)
    {
        super(props);
    }

    render(): React.ReactNode
    {
        const items = [];
        items.push(
            {
                keys: ["email"],
                renderer: EmailRenderer
            });

        items.push(
            {
                keys: ["address"],
                renderer: AddressRenderer
            });

        items.push(
            {
                keys: ["phone", "phone2", "intlPhone", "intlPhone2"],
                renderer: PhoneNumberRenderer
            }
        );

        const ignores = ["contactId", "contactType"];

        return <Fragment>
            {
                (this.props.data.contacts && this.props.data.contacts.length > 0)
                    ?
                    this.props.data.contacts.map((itm: Contact, i: number) =>
                    {
                        return <div className={"contact-emg"} key={i.toString()}>
                            <DictionaryControl data={itm} renderers={items} ignores={ignores} />
                        </div>;
                    })
                    :
                    <div className="text-center" id='error'>
                        <br />
                        <p className="error-text">No Contact data available</p>
                    </div>
            }
        </Fragment>;
    }
}